import { render, staticRenderFns } from "./TheCertificationList.vue?vue&type=template&id=ad9f85da&"
import script from "./TheCertificationList.vue?vue&type=script&lang=js&"
export * from "./TheCertificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports